import * as React from "react";
import { IClient } from "intake_shared/src/types";
import { TUpdateClient } from "../../clientUiTypes";
import { FormCheckbox } from "../../../bits/FormCheckbox/FormCheckbox";
import { Input } from "../../../bits/Input/Input";
import PhoneInput from "../../../bits/PhoneInput/PhoneInput";
import { formatLegacyPhoneNumber } from "../../../../../utils/utils";
import { TextArea } from "../../../bits/TextArea/TextArea";
import { Card } from "../../../bits/Card/Card";
import styles from "./GuardianDetailsFields.module.scss";

interface GuardianDetailsFieldsProps {
    client: IClient;
    updateClient: TUpdateClient;
}

export default function GuardianDetailsFields({
    client,
    updateClient,
}: GuardianDetailsFieldsProps) {
    const handleNoOtherGuardianChange = () => {
        const hasNoOtherGuardian = !client.has_no_other_parent_guardian;
        updateClient("has_no_other_parent_guardian", hasNoOtherGuardian);

        if (hasNoOtherGuardian) {
            updateClient("other_parent", "");
            updateClient("other_parent_last_name", "");
            updateClient("other_parent_email", "");
            updateClient("other_parent_phone", "");
            return;
        }

        updateClient("no_other_parent_guardian_reason", "");
    };

    return (
        <Card>
            <p className="sectionTitle">Primary Parent/Guardian</p>
            <div className="v2-form">
                <div className="gridThree">
                    <Input
                        label="First name"
                        isRequired
                        value={client.primary_parent ?? ""}
                        onChange={(event) =>
                            updateClient("primary_parent", event.target.value)
                        }
                    />
                    <Input
                        label="Last name"
                        isRequired
                        value={client.primary_parent_last_name ?? ""}
                        onChange={(event) =>
                            updateClient(
                                "primary_parent_last_name",
                                event.target.value
                            )
                        }
                    />
                </div>
                <p className={styles.subsectionTitle}>Other Parent/Guardian</p>
                <div className="v2-form">
                    {!client.has_no_other_parent_guardian && (
                        <div className="gridThree">
                            <Input
                                label="First name"
                                isRequired
                                value={client.other_parent ?? ""}
                                onChange={(event) =>
                                    updateClient("other_parent", event.target.value)
                                }
                            />
                            <Input
                                label="Last name"
                                isRequired
                                value={client.other_parent_last_name ?? ""}
                                onChange={(event) =>
                                    updateClient(
                                        "other_parent_last_name",
                                        event.target.value
                                    )
                                }
                            />
                            <Input
                                type="email"
                                label="Email address"
                                isRequired
                                value={client.other_parent_email ?? ""}
                                onChange={(event) =>
                                    updateClient(
                                        "other_parent_email",
                                        event.target.value
                                    )
                                }
                            />
                            <PhoneInput
                                placeholder="Phone"
                                label="Phone"
                                isRequired
                                value={formatLegacyPhoneNumber(
                                    client.other_parent_phone ?? ""
                                )}
                                onChange={(value) =>
                                    updateClient("other_parent_phone", value || "")
                                }
                            />
                        </div>
                    )}
                    <FormCheckbox
                        label="No other parent/guardian to list"
                        checked={Boolean(client.has_no_other_parent_guardian)}
                        onChange={handleNoOtherGuardianChange}
                    />
                    {client.has_no_other_parent_guardian && (
                        <TextArea
                            label="Reason no other parent/guardian is listed"
                            isRequired
                            value={client.no_other_parent_guardian_reason ?? ""}
                            onChange={(event) =>
                                updateClient(
                                    "no_other_parent_guardian_reason",
                                    event.target.value
                                )
                            }
                        />
                    )}
                </div>
            </div>
        </Card>
    );
}
